<template>
  <div class="tabs-container" :class="{ 'tabs-container__h5': isH5 }">
    <div class="tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ active: tab.isActive }"
        @click="selectTab(index)"
      >
        {{ tab.title }}
      </div>
      <div ref="indicator" class="indicator" />
    </div>
  </div>
</template>
<script>
import { isH5 } from "@saas/components/src";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  props: {
    tabsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      tabs: [],
      mouseOver: false,
      isH5: isH5(),
    };
  },
  watch: {
    tabsData: {
      handler(newVal) {
        this.tabs = newVal;
        if (this.tabs.length) {
          const index = this.tabs.findIndex((tab) => tab.isActive);
          this.updateIndicatorPosition(index);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateIndicatorPosition(0);
  },
  methods: {
    selectTab(index) {
      const selectedTab = this.tabs[index];
      
      // 上传日志：切换登录方式标签
      uploadLiveLog({
        message: "切换登录方式标签",
        module: "login",
        level: "info",
        tag: "userAction",
        extra: {
          component: "Tabs",
          tabIndex: index,
          tabType: selectedTab?.type || "",
          tabTitle: selectedTab?.title || "",
        },
      }, true);
      
      this.tabs.forEach((tab, i) => {
        tab.isActive = i === index;
      });
      this.updateIndicatorPosition(index);
      this.$emit("change", selectedTab);
    },
    updateIndicatorPosition(index) {
      if (this.$el) {
        const tab = this.$el.querySelector(`.tab:nth-child(${index + 1})`);
        const rect = tab.getBoundingClientRect();
        const tabsRect = this.$el
          .querySelector(".tabs")
          .getBoundingClientRect();
        const indicatorWidth = tab.offsetWidth;
        const indicatorLeft =
          rect.left -
          tabsRect.left +
          indicatorWidth / 2 -
          this.$refs.indicator.offsetWidth / 2;

        this.$refs.indicator.style.transform = `translateX(${indicatorLeft}px)`;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.tabs-container {
  display: flex;
  justify-content: center;
  .tabs {
    display: flex;
    position: relative;
  }
  .tab {
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    border: none;
    outline: none;
    font-weight: 400;
    font-size: 20px;
    color: #515350;
    &:first-child {
      margin-right: 52px;
    }
  }

  .tab.active {
    color: $saas-text-color;
    font-weight: 500;
  }
  .indicator {
    position: absolute;
    bottom: -7px;
    width: 20px;
    height: 3px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 2px;
    transition: transform 0.3s ease;
  }
}

.tabs-container__h5 {
  .tab {
    height: 0.6rem;
    line-height: 0.6rem;
    font-size: 0.4267rem;
    &:first-child {
      margin-right: 1.5467rem;
    }
  }
  .indicator {
    bottom: -0.2133rem;
    width: 0.5333rem;
    height: 0.08rem;
    border-radius: 0.0533rem;
  }
}
</style>
